// extracted by mini-css-extract-plugin
export var dropdownIcon = "_sh-6";
export var imgContainer = "_sh-3";
export var menuIcon = "_sh-5";
export var pillWrapper = "_sh-2";
export var pillsContainer = "_sh-1";
export var subscriptionCard = "_sh-0";
export var subscriptionLogo = "_sh-4";